import { render, staticRenderFns } from "./PrintPortal.vue?vue&type=template&id=1ffd2f23&"
import script from "./PrintPortal.vue?vue&type=script&lang=js&"
export * from "./PrintPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports